__turbopack_context__.v({
  "product_tabs": "HeaderTabs-module-scss-module__N1ek_G__product_tabs",
  "product_tabs_button": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_button",
  "product_tabs_button_bottom": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_button_bottom",
  "product_tabs_control": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_control",
  "product_tabs_desc": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_desc",
  "product_tabs_list": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_list",
  "product_tabs_panel": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_panel",
  "product_tabs_row": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_row",
  "product_tabs_subtitle": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_subtitle",
  "product_tabs_text": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_text",
  "product_tabs_title": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_title",
  "product_tabs_title_group": "HeaderTabs-module-scss-module__N1ek_G__product_tabs_title_group",
  "tab_button": "HeaderTabs-module-scss-module__N1ek_G__tab_button",
  "tab_list": "HeaderTabs-module-scss-module__N1ek_G__tab_list",
  "tab_list_112": "HeaderTabs-module-scss-module__N1ek_G__tab_list_112",
  "tab_list_170": "HeaderTabs-module-scss-module__N1ek_G__tab_list_170",
  "tab_list_grid": "HeaderTabs-module-scss-module__N1ek_G__tab_list_grid",
  "tab_list_mobile_112": "HeaderTabs-module-scss-module__N1ek_G__tab_list_mobile_112",
  "tab_list_mobile_170": "HeaderTabs-module-scss-module__N1ek_G__tab_list_mobile_170",
});
